<template>
  <layout-card>
    <div class="page-login-taipei-pass">
      <page-headline tag="h1" title="登入台北卡" title-class="text-center" :bar="false" />

      <b-tabs content-class="mt-3" fill pills nav-class="aaaaaaa">
        <b-tab title="一般會員" active>
          <validation-observer ref="loginFormObs" slim v-slot="{ handleSubmit }">
            <b-form ref="loginForm" @submit.prevent="handleSubmit(onLoginFormSubmit)">
              <validation-provider
                rules="required"
                v-slot="{ validated, valid, errors }"
                slim
                name="登入帳號"
              >
                <b-form-group :state="validated ? valid : null" :invalid-feedback="errors[0]">
                  <input-icon-group>
                    <template slot="prepend">
                      <i class="fas fa-user"></i>
                    </template>

                    <b-input
                      placeholder="手機號碼/電子郵件/金質會員帳號"
                      v-model="userLoginForm.account"
                      :state="validated ? valid : null"
                      spellcheck="false"
                    />
                  </input-icon-group>
                </b-form-group>
              </validation-provider>
              <validation-provider
                rules="required"
                v-slot="{ validated, valid, errors }"
                slim
                name="密碼"
              >
                <b-form-group :state="validated ? valid : null" :invalid-feedback="errors[0]">
                  <input-icon-group>
                    <template slot="prepend">
                      <i class="fas fa-lock"></i>
                    </template>

                    <b-input
                      placeholder="密碼"
                      :type="showPassword ? 'text' : 'password'"
                      v-model="userLoginForm.password"
                      :state="validated ? valid : null"
                      autocomplete="off"
                    />

                    <template slot="append">
                      <b-button variant="white" class="p-0 text-primary" @click="togglePassword">
                        <i class="far" :class="[showPassword ? 'fa-eye' : 'fa-eye-slash']"></i>
                      </b-button>
                    </template>
                  </input-icon-group>
                </b-form-group>
              </validation-provider>

              <b-form-group>
                <b-button variant="action" block class="btn-fat mb-3" type="submit">登入</b-button>
                <b-button
                  variant="outline-primary"
                  block
                  class="btn-fat"
                  type="button"
                  href="https://id.taipei/tpcd/user/passReset"
                  rel="noreferrer noopener"
                  target="_blank"
                  >忘記密碼</b-button
                >
              </b-form-group>
            </b-form>
          </validation-observer>
        </b-tab>
        <b-tab title="組織會員">
          <div class="py-4">
            <p class="text-secondary text-center mb-0">
              請連接讀卡機，並插上工商憑證或<br />組織憑證點擊進行登入
            </p>
          </div>

          <div>
            <b-button variant="action" block class="btn-fat mb-3">工商或組織憑證登入</b-button>
          </div>
        </b-tab>
      </b-tabs>

      <div class="mb-3">
        <b-button
          variant="outline-primary"
          block
          class="btn-fat"
          href="https://id.taipei/tpcd/registration"
          rel="noreferrer noopener"
          target="_blank"
          >申請臺北卡</b-button
        >
      </div>

      <divider tag="span" title="或" position="center" />

      <div class="mb-3">
        <b-button variant="outline-primary" block class="btn-fat" :to="{ name: 'home' }"
          >查詢收據資料</b-button
        >
      </div>
    </div>
  </layout-card>
</template>

<script>
import LayoutCard from '@/layouts/Card.vue';
import ApiMixin from '@/mixins/api';
import sleep from '@/utils/sleep';

export default {
  name: 'PageLoginTaipeiPass',

  components: {
    LayoutCard,
  },

  mixins: [ApiMixin],

  data() {
    return {
      showPassword: false,

      userLoginForm: {
        account: '',
        password: '',
      },
    };
  },

  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    async onLoginFormSubmit() {
      this.apiStart();

      try {
        await sleep(1);
        this.apiStop();
        // TODO: isSuccess is real api response;
        const isSuccess = Math.round(new Date().getTime() / 1000) % 2 === 1;

        // 顯示 API 結果訊息 (type, message, title)
        if (isSuccess === false) {
          await this.showApiMessage(
            'error',
            '訊息內容訊息內容訊息內容訊息內容訊息內容訊息內容訊息內容訊息內容訊息內容訊息內容訊息內容',
            '執行失敗'
            // {
            //   confirm: true, // 啟用「取消」按鈕
            // }
          );
        }

        if (isSuccess) {
          this.$router.push({
            name: 'result',
          });
        }
      } catch (error) {
        this.apiStop();
        console.error(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page-login-taipei-pass {
  min-height: 520px;
}
</style>
